<template>
    <div class="autocomplete">
        <textarea
            type="text"
            class="ac-input"
            :class="classList"
            @input="inputEvent"
            @keyup.enter="$emit('press-enter')"
            :value="value"
            :disabled="disable"
            :placeholder="placeholder"
            ref="input">
        </textarea>
    </div>
</template>

<script>
  // eslint-disable-next-line
  import {typeahead} from 'typeahead.js';
  import $ from 'jquery';

  export default {
    name: 'AutocompleteTextarea',
    data() {
      return {
        testStr: '',
        typeheadObj: null,
        timeout: null,
      };
    },
    props: {
      list: {
        type: Array,
        required: true,
        default: () => {
          return [];
        },
      },
      value: {
        type: String,
        default: '',
      },
      classList: {
        type: Array,
      },
      disable: {
        type: Boolean,
      },
      placeholder: {
        type: String,
      },
      hint: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      inputEvent() {
        this.timeout = setTimeout(() => {
          this.$emit('input', this.$refs.input.value);
        }, 600);
      },
      init() {
        this.typeheadObj = $(this.$refs.input).typeahead(
            {
              hint: this.hint,
              highlight: true,
              minLength: 0,
            },
            {
              name: 'states',
              source: this.substringMatcher(this.list),
            },
        );

        this.typeheadObj.on('typeahead:change', () => {
          // console.log('typeahead:change', value);
          // this.$emit('input', value);
        });

        this.typeheadObj.on('typeahead:select', (e, value) => {
          // console.log('typeahead:select', value);
          this.$emit('input', value);
        });
      },
      substringMatcher(strs) {
        return function findMatches(q, cb) {
          // an array that will be populated with substring matches
          const matches = [];

          // regex used to determine if a string contains the substring `q`
          const substrRegex = new RegExp(q, 'i');

          // iterate through the pool of strings and for any string that
          // contains the substring `q`, add it to the `matches` array
          $.each(strs, (i, str) => {
            if (substrRegex.test(str)) {
              matches.push(str);
            }
          });

          cb(matches);
        };
      },
    },
    mounted() {
      this.init();
    },
  };
</script>

<style lang="less">
    .ac-input {
        border: none;
        color: #333333;
        padding: 6px;

        width: 100%;

        &.p0 {
            padding: 0;
        }

        &.specify {
            border: 1px solid #fdad50;
            padding: 5px 4px;

            width: 100%;
        }

        &:focus {
            outline: none;
        }

        &.tb-input {
            display: inline-block;
            color: #202020;
            font-size: 13px;
            font-weight: 400;
            line-height: 1;
            width: 231px;
            height: 23px;
            padding-left: 5px;
            border-radius: 0;
            box-shadow: none;
            border: 1px solid #AAAAAA;
            background: #fff;
        }

        &.search-input-template {
            padding: 2px 10px;
            height: 35px;
            border: 1px solid #a6c3d5;
            color: #848284;
            font-size: 13px;
            line-height: 1;
            background: #fff;
        }

        &.search-input {
            .search-input-template();
            width: 612px;
        }

        &.search-input-sc5 {
            .search-input-template();

            &::placeholder {
                font-style: italic;
            }
        }

        &.alert-name-input {
            display: block;
            width: 1096px;
            border: 1px solid #bad0de;
            padding-left: 5px;
            height: 30px;
            background: #fff;
        }
        &.modal-input {
            display: inline-block;
            width: 400px;
            height: 30px;
            border: 1px solid #a6c3d5;
            padding-left: 5px;

            &:focus {
                outline: 1px solid #fd9c2d;
            }
        }

        &.modal-number-input {
            display: inline-block;
            width: 64px;
            height: 30px;
            border: 1px solid #a6c3d5;
            padding-left: 5px;
            text-align: center;
            &:focus {
                outline: 1px solid #fd9c2d;
            }
        }

        &.modal-textarea-input {
            width: 100% !important;
            height: 83px !important;
            border: 1px solid #b5c9d7;
            resize: none;
            margin-bottom: 18px;
        }
    }

    .twitter-typeahead {
        width: 100%;
    }

    .tt-menu {
        background: #fff;
        border: 1px solid #008cce;
        text-align: left;

        .tt-suggestion {
            padding: 2px 4px;

            &.tt-cursor, &:hover {
                cursor: pointer;
                background: #aedeff;
            }
        }
    }
</style>
